import Invitation from "./invitations";

export default Invitation;
